import functions from '../functions.js';
import { details } from './details';
import { Calendar } from '../components/calendar.js'

$(() => {
    detailsAccommodation.init();
})

const detailsAccommodation = {
    $form: null,
    form: null,
    $calendar: null,
    params: {
        objectId: null, 
        unitId: null, 
        guests: null, 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        objectGroupId: null,
        calcErrorMessages: null,
    },
    init() {

        this.$calendar = $('.datepicker-calendar');
        this.params.objectGroupId = $('[data-objectgroupid]').attr('data-objectgroupid');
        
        if(! this.$calendar.length || this.params.objectGroupId != 1) {
            return;
        }

        this.$form = $('form#details-booking');
        this.form = this.$form[0];

        this.params.objectId = this.$form.attr('data-objectid');
        this.params.calcErrorMessages = $('[data-calcErrorMessages]')[0] ? JSON.parse($('[data-calcErrorMessages]').attr('data-calcErrorMessages')) : null;

        this.$config = $('[data-calendarConfig]');
        this.config = this.$config.length ? JSON.parse(this.$config.attr('data-calendarconfig')) : null;

        this.$calendar.length && new Calendar(this.$calendar, {
            availabilityMask: this.config.availabilityMask,
            minStay: this.config.minStay,
            minDate: this.config.startDate,
            translations : this.config.translations,
        }, this.callbackOnDatesSelected);

        this.getParams();
        
        this.form && functions.setFormData(this.form, this.params);

        this.getCalculation();

        this.$form.on('change', e => {
            e.preventDefault();
            let params = functions.getFormData($(e.currentTarget));
            functions.setUrlData(params, true);
        });

        $('.btn-clear-dates').on('click', e => {
            this.getParams();
            $('[name="dates"]')[0]._flatpickr.setDate([]);
            this.params.dates = this.params.dateTo = this.params.dateFrom = null;
            functions.setUrlData({guests: this.params.guests}, true);
        });

        $('.btn-booking').on('click', e => {
            e.preventDefault();
        });

        $(window).on('hashchange', e => {
            this.getParams();
            //console.log(this.params);
            this.getCalculation();
        });

    },
    getParams() {
        this.params = details.getParams(this.params);
        this.params.guests = this.params.guests && this.params.guests.startsWith('0') ? null : this.params.guests;
        if(this.params.dates) {
            this.splitCalendarDates(this.params.dates);
        } else if(this.params.dateFrom && this.params.dateTo) {
            this.params.dates = this.params.dateFrom + ' - ' + this.params.dateTo;
        }
    },
    splitCalendarDates(dates) {
        if(dates || dates == '') {
            const aDates = dates.split(' - ');
            this.params.dateFrom = aDates[0] ? aDates[0] : null;
            this.params.dateTo = aDates[1] ? aDates[1] : null;
        }
    },
    callbackOnDatesSelected(from, to) {
        
        /*$('.calendar-message').removeClass('d-none').text(details.getCalcErrorMessage({type : ! from ? 'selectDates' : 'selectDepartureDate'}));
        if ( to && ! to[1]) {
            $('.btn-booking').addClass('disabled');
        }*/
    },
    getCalculation() {
        //console.log(this.params);
        const calculation = details.getCalculation(this.params);
        if(calculation) {
            //this.loader(this.params.unitId ? $('.unit[data-unitid=' + this.params.unitId + ']').find('.unit-spinner') : null);
            calculation
            .done(response => {
                    this.calculationDone(response);
                }).fail(error => {
                    console.log(error);
                });
        } else {
            $('.unit-price-payment-key').toggleClass('d-none', false);

            $('.calc-period').toggleClass('d-none', true);

            //$('.unit-price-discount-title').toggleClass('d-none', false);

            //$('.btn-booking-container').toggleClass('d-none', false);

            //$('.btn-booking').toggleClass('d-none', true);
            $('.no-period-label').toggleClass('d-none', false);

            $('.unit-error-container').toggleClass('d-none', true);

            $('.unit-error-container').toggleClass('d-none', true);
            
            $('.unit-price-total-label').toggleClass('d-none', true);

            $('.unit').each((index, elem) => {
                const $elem = $(elem);
                const $unitPriceTotal = $elem.find('.unit-price-total');
                const $unitPriceOld = $elem.find('.unit-price-old');

                let unitPriceOld = $unitPriceOld.attr('data-unitPriceOld');

                $unitPriceTotal.text($unitPriceTotal.attr('data-unitPriceTotal'));
                $unitPriceOld.text(unitPriceOld != '€ 0' ? unitPriceOld : '');
            });
        }
    },
    calculationDone(response) {
        if(response.status) {
            const data = response.data || [];

            //console.log(data);

            Object.entries(data).forEach(unit => {
                const unitId = unit[0];
                const unitData = unit[1];
                const $unit = $('.unit[data-unitid=' + unitId + ']');

                if(details.isBookable(unitData)) {
                    const unitCalc = unitData.calc;
                    const calcItems = unitCalc.items;
                    const total = unitCalc.total;
                    const currencySymbol = unitCalc.currencySymbol;

                    let priceOld = details.getCalcTotalOld(calcItems);
                    let discountTitle = details.getCalcDiscountTitle(calcItems);

                    if(discountTitle) {
                        $unit.find('.unit-price-discount-title').text(discountTitle);
                        $unit.find('.fm-discount-title').text(discountTitle ? discountTitle : '');
                    }

                    if(priceOld > total) {
                        $unit.find('.unit-price-old').text(currencySymbol + ' ' + functions.formatMoney(priceOld, 0, '.', ','));
                    }

                    $unit.find('.unit-price-total-label').removeClass('d-none');
                    $unit.find('.unit-price-total').text(currencySymbol + ' ' + functions.formatMoney(total, 0, '.', ','));
                    
                    //this.printDates();

                    const $btnBooking = $unit.find('.btn-booking[data-unitId=' + unitId + ']');

                    $btnBooking.text(unitData.booking.status == 'Request' ? $btnBooking.attr('data-requestLabel') : $btnBooking.attr('data-bookingLabel'));

                    if($btnBooking.attr('data-href')) {
                        $btnBooking.attr('data-href',
                            $btnBooking.attr('data-href').split('?')[0] +
                            '?objectGroupId=' + this.params.objectGroupId +
                            '&unitId=' + unitId +
                            '&dateFrom=' + this.params.dateFrom +
                            '&dateTo=' + this.params.dateTo +
                            '&guests=' + this.params.guests +
                            '&addAllOptionals=' + 1
                        );
                    }

                    $btnBooking.on('click', e => {
                        e.preventDefault();
                        location = $(e.currentTarget).attr('data-href');
                    });
                    
                }

                $unit.find('.unit-price-label').toggleClass('d-none', details.isBookable(unitData));
                $unit.find('.unit-price').toggleClass('d-none', ! details.isBookable(unitData));

                $unit.find('.unit-price-discount-title').toggleClass('d-none', ! details.isBookable(unitData));
                $unit.find('.unit-price-payment-key').toggleClass('d-none', details.isBookable(unitData));

                $unit.find('.fm-discount').toggleClass('d-none', details.isBookable(unitData));
                
                $unit.find('.fm-discount-valid-until').toggleClass('d-none', details.isBookable(unitData));
                //$unit.find('.fm-discount-valid-until-date').text(rate.validUntil ? rate.validUntil : '');

                $unit.find('.no-period-label').toggleClass('d-none', details.isBookable(unitData));
                $unit.find('.calc-period').toggleClass('d-none', ! details.isBookable(unitData));

                let dateFrom = new Date(this.params.dateFrom);
                dateFrom = ('0' + dateFrom.getDate()).slice(-2) + '.' + ('0' + (dateFrom.getMonth() + 1)).slice(-2) + '.' + dateFrom.getFullYear();
                $unit.find('.calc-date-from').text(dateFrom);

                let dateTo = new Date(this.params.dateTo);
                dateTo = ('0' + dateTo.getDate()).slice(-2) + '.' + ('0' + (dateTo.getMonth() + 1)).slice(-2) + '.' + dateTo.getFullYear();
                $unit.find('.calc-date-to').text(dateTo);

                //$unit.find('.btn-booking').toggleClass('d-none', ! details.isBookable(unitData));

                //$unit.find('.btn-booking-container').toggleClass('d-none', ! details.isBookable(unitData));
                //$unit.find('.btn-request-nobookable').toggleClass('d-none', details.isBookable(unitData));

                let error = details.getCalcErrorMessage(this.params.calcErrorMessages, unitData);
                $unit.find('.unit-error-container').toggleClass('d-none', details.isBookable(unitData));
                $unit.find('.unit-error-container').text(error);
            });
        }
    },
    loader($target = null) {
        $target ? $target.addClass('active') : $('.unit-spinner').addClass('active');
        setTimeout(() => {
            $target ? $target.removeClass('active') : $('.unit-spinner').removeClass('active');
        }, 800);
    }
};
